// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cj-4";
export var closeButton = "_cj-6";
export var dismissButton = "_cj-3";
export var editImageWithAiContainer = "_cj-8";
export var imageUploadWrapper = "_cj-7";
export var misspelledWord = "_cj-5";
export var spellCheckContainer = "_cj-2";
export var spin = "_cj-1";
export var spinning = "_cj-0";